import { FetchesData } from "kinnect-mixins";
import { KForm, KTextEditor } from "kinnect-general";
import { VTO } from "kinnect-models";

export default KForm.extend( {
	name: "VtoForm",

	mixins: [ FetchesData ],

	props: {
		redirect: {
			...KForm.options.props.redirect,
			default: () => [ "back", { name: "vto" } ]
		}
	},

	data: () => ( {
		formFields: {
			coreFocus: null,
			coreValues: null,
			issuesList: null,
			marketingStrategy: null,
			oneYearPlan: null,
			rocks: null,
			tenYearTarget: null,
			threeYearPicture: null
		},
		vto: {}
	} ),

	watch: {
		vto: {
			handler( vto ) {
				if ( vto ) {
					Object.keys( this.formFields ).forEach( key => {
						if ( vto.hasOwnProperty( key ) ) {
							this.formFields[key] = vto[key];
						}
					} );
				}
			},
			immediate: true
		}
	},

	methods: {
		async fetchVTO() {
			this.vto = await VTO.first();
		},

		async fetch() {
			await this.fetchVTO();
		}
	},

	render() {
		return <KForm
			attrs={{
				...this.$props,
				action: "vto",
				data: this.formFields,
				method: "post"
			}}
			on={this.$listeners}
		>
			<h2 class="text-h4 mb-2">Vision</h2>

			<KTextEditor
				label="Core Values*"
				required
				vModel={this.formFields.coreValues}
				validationName="core values"
				validationRules="required"
			></KTextEditor>

			<KTextEditor
				label="Core Focus*"
				required
				vModel={this.formFields.coreFocus}
				validationName="core focus"
				validationRules="required"
			></KTextEditor>

			<KTextEditor
				label="10-Year Target*"
				required
				vModel={this.formFields.tenYearTarget}
				validationName="10-year target"
				validationRules="required"
			></KTextEditor>

			<KTextEditor
				label="Marketing Strategy*"
				required
				vModel={this.formFields.marketingStrategy}
				validationName="marketing strategy"
				validationRules="required"
			></KTextEditor>

			<KTextEditor
				label="3-Year Picture*"
				required
				vModel={this.formFields.threeYearPicture}
				validationName="3-year picture"
				validationRules="required"
			></KTextEditor>

			<h2 class="text-h4 mb-2 mt-4">Traction</h2>

			<KTextEditor
				label="1-Year Plan*"
				required
				vModel={this.formFields.oneYearPlan}
				validationName="1-year plan"
				validationRules="required"
			></KTextEditor>

			<KTextEditor
				label="Rocks*"
				required
				vModel={this.formFields.rocks}
				validationName="rocks"
				validationRules="required"
			></KTextEditor>

			<KTextEditor
				label="Issues List*"
				required
				vModel={this.formFields.issuesList}
				validationName="issues list"
				validationRules="required"
			></KTextEditor>
		</KForm>;
	}
} );
